import Urls from "../../urlLink";
import { createApiClient, createApiService } from "../../utils/apiClientFactory";

const client = createApiClient(Urls.crmApiUrl);

const storePermission = createApiService(client, {
  getModule: ["get", "/Module"],
  getLowModuleList: ["get", "/Module/getLowModuleList"],
  getCrmLevel: ["get", "/Module/getCrmLevel"],
});

export default storePermission;
